module.exports = __webpack_public_path__ + "img/tyynyt.ca00008b.jpeg";